var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section banner",style:({
			backgroundImage: ("url(\"" + _vm.backgroundImage + "\")")
		}),attrs:{"id":"banner"}},[_c('div',{staticClass:"banner__contents"},[_c('counter-widget',{attrs:{"id":_vm.widgetId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }